import React, {Component} from 'react';
import ContainersCard from './ContainersCard';
import { observer } from "mobx-react";
import ScrollMenu from "react-horizontal-scrolling-menu";
import { formataParaDiaMesAno } from '../../../utils/formatar';
import { IconeSetaEsquerda, IconeSetaDireita } from './Icones';

@observer
export default class ContainersLista extends Component {
    constructor(props){
        super(props);

        this.controller = this.props.controller;
        
        this.menu = null;
        this.state = {
            selected: false
        };
    }

    onSelect = key => {
        this.setState({selected : true});
        this.controller.clickCard(key);
    }

    render() {
        let lista = [];

        this.controller.containers.map((card, x) => {
                lista.push( <ContainersCard key={x}
                    index={x}
                    ativo={ card.container.UnitId === this.props.gkeyContainerAtivo}
                    EntradaData={ (card.container.EntradaData) ? formataParaDiaMesAno(card.container.EntradaData) : "---" }
                    SaidaData={ (card.container.SaidaData) ? formataParaDiaMesAno(card.container.SaidaData) : "---" }
                    Categoria={ card.container.Subcategoria && card.container.Subcategoria.toUpperCase() === 'CABOTAGEM' ? card.container.Subcategoria : card.container.Categoria } />);
            })

        const ArrowLeft = <IconeSetaEsquerda tamanho="2x"/>;
        const ArrowRight = <IconeSetaDireita tamanho="2x"/>;

        return(
            <div>
                <ScrollMenu
                    ref={el => (this.menu = el)}
                    data={lista}
                    arrowLeft={ArrowLeft}
                    arrowRight={ArrowRight}
                    onSelect={this.onSelect}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/ContainersLista.js